import type { ListingAgreementDetails } from '@urbanx/agx.campaigns.client';
import dayjs from 'dayjs';
import { toInclusiveDate } from '@urbanx/agx.ui-components2';

const isOpenAgreement = (agreementDetails?: ListingAgreementDetails) =>
  agreementDetails?.agreementType?.toLowerCase() === 'open';

const hasAgreementType = (agreementDetails?: ListingAgreementDetails) =>
  Boolean(agreementDetails?.agreementType);

const hasAgreementStart = (agreementDetails?: ListingAgreementDetails) =>
  Boolean(agreementDetails?.startDate);

const hasAgreementEnd = (agreementDetails?: ListingAgreementDetails) =>
  Boolean(agreementDetails?.endDateExclusive);

export const areAgreementDatesOrdered = (agreementDetails?: ListingAgreementDetails) =>
  !agreementDetails?.startDate ||
  !agreementDetails.endDateExclusive ||
  dayjs(toInclusiveDate(agreementDetails.endDateExclusive)).diff(
    dayjs(agreementDetails.startDate),
    'day'
  ) >= 0;

export const hasExceededAgreementPeriod = (agreementDetails?: ListingAgreementDetails) => {
  if (
    isOpenAgreement(agreementDetails) ||
    !agreementDetails?.startDate ||
    !agreementDetails.endDateExclusive
  ) {
    return false;
  }

  return (
    dayjs(agreementDetails.endDateExclusive).diff(dayjs(agreementDetails.startDate), 'day') > 90
  );
};

export const hasValidQldAgreementDetails = (
  agreementDetails: ListingAgreementDetails | undefined,
  hasAgreementTypeTask: boolean
) =>
  !hasAgreementTypeTask ||
  (hasAgreementType(agreementDetails) &&
    hasAgreementStart(agreementDetails) &&
    (isOpenAgreement(agreementDetails) || hasAgreementEnd(agreementDetails)) &&
    areAgreementDatesOrdered(agreementDetails) &&
    !hasExceededAgreementPeriod(agreementDetails));

export const hasValidNswAgreementDetails = (
  agreementDetails: ListingAgreementDetails | undefined,
  hasAgreementDetailsTask: boolean
) =>
  !hasAgreementDetailsTask ||
  (hasAgreementStart(agreementDetails) &&
    hasAgreementEnd(agreementDetails) &&
    areAgreementDatesOrdered(agreementDetails));

export const getQldAgreementTypeStepCompletionValues = (
  agreementDetails?: ListingAgreementDetails
) => {
  if (!agreementDetails) {
    return [];
  }

  return [
    hasAgreementStart(agreementDetails),
    isOpenAgreement(agreementDetails) || hasAgreementEnd(agreementDetails),
    areAgreementDatesOrdered(agreementDetails) && !hasExceededAgreementPeriod(agreementDetails),
  ];
};

export const isAgreementTypeOpen = isOpenAgreement;
